import React from "react";

import CloseIcon from "@material-ui/icons/Close";
import { Select } from "antd";

import { CATEGORIES, Category } from "../types";

const { Option } = Select;

interface CategorySelectProps {
  value: Category[];
  onChange: (value: Category[]) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

const CategorySelect: React.FC<CategorySelectProps> = ({ value, onChange, ...rest }) => {
  return (
    <Select
      allowClear
      clearIcon={<CloseIcon className="anticon" />}
      removeIcon={<CloseIcon className="anticon" />}
      mode="multiple"
      style={{ width: "100%" }}
      value={value}
      onChange={onChange}
      placeholder="Select categories..."
      data-testid="category-select"
      {...rest}>
      {CATEGORIES.map((category) => (
        <Option key={category} value={category}>
          {category}
        </Option>
      ))}
    </Select>
  );
};

export default CategorySelect;
